export { LandingFeatureStorePage } from './lib/landing-feature-store-page'

export { getStaticPathsGenerator } from './lib/get-static-path'

export { getStaticProps } from './lib/get-static-props'
